import {Epic} from 'redux-observable'
import {filter, mergeMap} from 'rxjs/operators'
import {invalidateCacheAction, refreshBSModelAction} from 'module/BSCollection/action/BSCollectionAction'
import {selBSCollectionByIdDict} from 'module/BSCollection/selector/BSCollectionSelector'
import {SisName} from 'util/SisName'
import {BSAttr} from 'module/BSEntry/BSAttr'
import {Booking, Persurl} from 'generated/JavaTOmodifications'

const InvalidateIstZeitEpic: Epic = (action$, state$) => action$.pipe(
	filter(refreshBSModelAction.match),
	mergeMap(({payload: {remove, add}}) => {
		const byId = selBSCollectionByIdDict[SisName.Ist]?.(state$.value)
		if (!byId) return []
		return [...(remove || []), ...(add || [])].flatMap(model => {
			if (!model || ![SisName.Booking, SisName.Persurl].includes(model.sisName)) return []
			const persNr = (model as Persurl | Booking).persNr
			const start = BSAttr.getStartDateTime(model)
			const end = BSAttr.getEndDateTime(model)
			return [invalidateCacheAction({
				sisName: SisName.Ist,
				owners: [persNr],
				startTS: +start,
				endTS: +end,
			})]
		})
	}),
)

export const BSIstZeitEpic = InvalidateIstZeitEpic